import { APPLICATION_ID } from '@hrms/common/constant/global';
import { apiService } from '..';
import { GetRoleConfigAPIResponseInterface } from './types';

export const getRoleConfig = async () => {
  const response = await apiService.get<GetRoleConfigAPIResponseInterface>({
    path: 'api/v1/ui/role',
    params: {
      applicationId: APPLICATION_ID,
    },
  });
  return response.data;
};
